import { CellContext } from '@tanstack/react-table';

import Box from 'shared_DEPRECATED/components/Box';

import {
  COACHING_MODE,
  COACHING_MODE_LABELS,
} from 'features/participants/config';
import { CoachingMode } from 'features/participants/config/types';
import { useCoachingModeMutation } from 'features/participants/hooks/mutation/useCoachingMode';
import { useUpdateParticipantsQuery } from 'features/participants/hooks/query/useUpdateParticipants';

import { Dropdown, DropdownItem } from 'shared/components/Dropdown';
import { Typography } from 'shared/components/Typography';

export const ParticipantsTableCoachingModeCell = ({
  row,
  getValue,
}: CellContext<any, CoachingMode>) => {
  const value = getValue();
  const { userInfo } = row.original as unknown as {
    userInfo: {
      email: string;
    };
  };
  const { mutate: updateCoachingMode } = useCoachingModeMutation({
    userEmail: userInfo.email,
    onUpdateQuery: useUpdateParticipantsQuery,
  });

  const handleCoachingModeChange = (newMode: string | number) => {
    if (
      newMode !== value &&
      Object.values(COACHING_MODE).includes(newMode as CoachingMode)
    ) {
      updateCoachingMode({
        currentMode: value,
        updatedMode: newMode as CoachingMode,
      });
    }
  };

  return (
    <Box style={{ maxWidth: '10rem' }}>
      <Dropdown
        dataTestid="coaching-mode-dropdown"
        selectedValue={value}
        onItemSelect={handleCoachingModeChange}
        anchorContent={
          <Typography
            type="small"
            color="black"
            as="span"
            dataTestid="participant-coaching-mode"
          >
            {COACHING_MODE_LABELS[value]}
          </Typography>
        }
      >
        {Object.values(COACHING_MODE).map((mode) => (
          <DropdownItem
            key={mode}
            value={mode}
            dataTestid="coaching-mode-dropdown-option"
          >
            <Typography type="small" color="black">
              {COACHING_MODE_LABELS[mode]}
            </Typography>
          </DropdownItem>
        ))}
      </Dropdown>
    </Box>
  );
};
